import { define, auto, Store, type } from 'type-r'
import NutritionLabel from './nutrition-label'

@define
export default class SiteStore extends Store {
    @type(NutritionLabel).as model: NutritionLabel
    @auto productId: number
    @auto productIds: number[]
    
    @auto combo: boolean
    @auto menu: any
    @auto ingredients: any
    initialize() {
        this.model = new NutritionLabel();
    }    
}

var data = window.menu ?? (window.sitestore ?? {});

if (data.menu && data.menu.slots && data.menu.slots.length)
    data.combo = true;

export var currentStore = new SiteStore(data, { parse: true });
